export const getRedirectUrlWithParams = (url) => {
	const searchParams = typeof window !== 'undefined' ? window.location.search : '';
	return `${url}${searchParams}`;
};
